// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#focusCatcher{opacity:0;height:0;width:0;width:100px;border:0;padding:0;position:fixed;top:0;left:0;z-index:99999}", ""]);
// Exports
module.exports = exports;
